import React, { FC, useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { SignInSectionContainer, SignInFormContainer } from './style'
import FormInputField from 'components/FormInputField'
import PhoneNumberInput from 'components/PhoneNumberInput'
import StyledButton from 'components/Button'
import { colors } from 'constants/colors'
import { useAuth } from 'customHooks/useAuth'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
import signIn from 'assets/images/signIn.jpg';
import { Link } from "react-router-dom";

const SignInSection: FC = () => {


  const history = useHistory()
  const { validToken, userSignIn } = useAuth()
  // Only redirect users who were already signed in when this screen opened.
  const initialValidToken = useRef(validToken)
  const [emailSignIn, setEmailSignIn] = useState(true)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(false)
  const [phoneNumberError, setPhoneNumberError] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState(false)

  useGlobalAlerts();


  useEffect(() => {
    if(initialValidToken.current) {
      history.push('/')
    }
  },[history])


  const handleSignIn = () => {

    if(emailSignIn) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
        && password.length >= 8
      ) {
        setEmailError(false)
        setPasswordError(false)
        userSignIn(email, password, '/account/dashboard');
      } else {
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          setEmailError(true)
        }
    
        if (password.length < 8) {
          setPasswordError(true)
        }
        const content = 'Invalid password or email'
        console.log(content)
      }
    } else {
      if(phoneNumberValidity && password.length >= 8) {
        setPhoneNumberError(false)
        setPasswordError(false)
        userSignIn(phoneNumber, password, '/account/dashboard');
      } else {

        if (password.length < 8) {
          setPasswordError(true)
        }
        const content = 'Invalid password or phone number'
        console.log(content)
      }
    }
  }

  return (
    <SignInSectionContainer>
      <div className="innerContainer">

        <SignInFormContainer>

          <div className="container">

            <div className="formTitle">Sign in</div>
            <div className="inputFieldContainer">
              {emailSignIn? (
                <FormInputField
                  label="EMAIL"
                  isRequired
                  inputHeight="48px"
                  borderColor={colors.signInBorderColor}
                  marginBottom="32px"
                  placeholder="User Email"
                  labelWeight="400"
                  value={email}
                  error={emailError}
                  errorMessage='Please enter a valid email address and try again.'
                  onChange={(e) => {
                    setEmail(e.target.value)
                    if(emailError) {
                      setEmailError(false)
                    }
                  }}
                />
              ): (
                  <PhoneNumberInput
                    className='phoneNumberInput'
                    label="PHONE"
                    isRequired={true}
                    labelPosition='left'
                    error={!phoneNumberValidity && phoneNumberError}
                    errorMessage='Please enter a valid phone number'
                    inputHeight="48px"
                    marginBottom={'32px'}
                    labelWeight="400"
                    onChangeNumber={setPhoneNumber}
                    setPhoneNumberValidity={setPhoneNumberValidity}
                    onBlur={() => {
                      if(!phoneNumberValidity&&phoneNumber.length<3) {
                        setPhoneNumberError(true)
                      }
                    }}
                  />
                )
              }
              <FormInputField
                label="PASSWORD"
                isRequired
                borderColor={colors.signInBorderColor}
                marginBottom="8px"
                placeholder="Password"
                value={password}
                error={passwordError}
                labelWeight="400"
                errorMessage='Please enter a valid password'
                inputHeight="48px"
                type="password"
                onChange={(e) => {
                  setPassword(e.target.value)
                  if(passwordError) {
                    setPasswordError(false)
                  }
                }}
              />
              <div
                className="tips forgotPassTop"
                onClick={() => {
                  history.push('/forgot-password')
                }}
                style={{marginTop: passwordError?25: 0}}
              >
                Forgot your password?
              </div>
            </div>
            <div className="buttonContainer">
              <StyledButton
               className="signInButton"
                width="111px"
                height="48px"
                fontSize={18}
                fontWeight={700}
                onClick={handleSignIn}
              >
                Sign in
              </StyledButton>
              <div className='dividerContainer'>
                <hr className="divider" />
                <span>or</span>
                <hr className="divider" />
              </div>
              <div
                className="tips emailPhone"
                onClick={() => setEmailSignIn(!emailSignIn)}
              >
                Sign in with {emailSignIn? 'phone number': 'email'}
              </div>
              <div className="dontHaveAcc">You don't have an account? <span
                className="tips"
                onClick={() => {
                  history.push('/sign-up')
                }}
              >
                Sign up
              </span>
              </div>
              <div className="butLinks">
  <Link to="/forgot-password">Forgot your password?</Link>
  &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
  <Link to="/help">Need help?</Link>
</div>
            </div>
            <div className="dontHaveAccMobile">You don't have an account? <span
                className="tips"
                onClick={() => {
                  history.push('/sign-up')
                }}
              >
                Sign up
              </span>
              </div>
          </div>
        </SignInFormContainer>
        <div className="signInImageBox">
        <img src={signIn} alt="" className="signInImage" />
        </div>
        
      </div>
    </SignInSectionContainer>
  );
};

export default SignInSection;
